import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { GameLogo } from '../game/GameLogo';

interface WelcomeScreenProps {
  onHowToPlay: () => void;
  onLetsPlay: () => void;
  className?: string;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  onHowToPlay,
  onLetsPlay,
  className = '',
}) => {
  const { t } = useTranslation();

  const { iframeParams } = useAuth();

  return (
    <div
      data-test-id="welcome-screen"
      className={`fixed inset-0 bg-app-background flex flex-col items-center justify-center px-6 py-8 ${className}`}
    >
      <div className="flex flex-col items-center justify-center flex-1 w-full max-w-md space-y-8 sm:space-y-12 min-h-0">
        {/* Logo */}
        <div className="flex justify-center flex-shrink-0">
          <div className="w-[140px] h-[110px] sm:w-[180px] sm:h-[140px] flex items-center justify-center">
            <GameLogo
              location={iframeParams.location}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        </div>

        {/* Tagline */}
        <div
          data-test-id="welcome-tagline"
          className="text-center space-y-1 sm:space-y-2 flex-shrink-0"
        >
          <h1 className="text-text-primary text-xl sm:text-2xl font-bold leading-relaxed">
            {t('welcome.tagline1')}
          </h1>
          <h2 className="text-text-primary text-xl sm:text-2xl font-bold leading-relaxed">
            {t('welcome.tagline2')}
          </h2>
          <h3 className="text-text-primary text-xl sm:text-2xl font-bold leading-relaxed">
            {t('welcome.tagline3')}
          </h3>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3 sm:space-y-4 w-full max-w-sm flex-shrink-0">
          <Button
            data-test-id="how-to-play-btn"
            variant="secondary"
            onClick={onHowToPlay}
            className="w-full h-12 sm:h-14 text-text-primary text-base sm:text-lg font-semibold bg-[#555555] hover:bg-[#444444]"
          >
            {t('welcome.howToPlay')}
          </Button>
          <Button
            data-test-id="lets-play-btn"
            variant="bet99"
            onClick={onLetsPlay}
            className="w-full h-12 sm:h-14 text-base sm:text-lg font-semibold"
          >
            {t('welcome.letsPlay')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
